const paymentTermsSelectorElementItemized = document.getElementById('test-payment-terms-selector');
const formDataItemized = document.getElementById('form-data');
const addPaymentTerms = document.getElementById('add-payment-terms');

paymentTermsSelectorElementItemized.addEventListener('outputPaymentTermForm', function(event) {
  if ((event as any).detail) {
    formDataItemized.innerText = JSON.stringify((event as any).detail);
  }
});

paymentTermsSelectorElementItemized.addEventListener('openPaymentTermsModal', function(event) {
  if ((event as any).detail) {
    addPaymentTerms.innerText = JSON.stringify((event as any).detail);
  }
});

